import './i18n';
import { initSentry } from '@repo/shared/instrument-factory';
import React from 'react';

// Sentry project: 'zoom-sidebar' (id 4507228247621632).
// Prior to this commit apps/zoom/src/instrument.js existed but was never
// imported, so Sentry never actually started for the Zoom app. Wiring it up
// here. Browser tracing stays off (zoom runs inside the Zoom in-app browser
// where the tracing integration has had stability issues).
initSentry({
  dsn: "https://b4093ff2e39bafc9b584c95fbd40eb0b@o4507221443936256.ingest.us.sentry.io/4507228247621632",
});
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
